import { Input, InputProps } from "@chakra-ui/react";
import { useCustomFormats } from "hooks/useCustomFormat";

interface DateInputProps extends InputProps {}

export function DateInput({ ...props }: DateInputProps) {
	const { dateFormat } = useCustomFormats();

	return (
		<Input type="date" placeholder={dateFormat} variant="primary" {...props} />
	);
}
